import * as types from './ActionTypes';

export const setErrorDialog = (payload) => dispatch => {
  dispatch({
    type: types.SET_ERROR_DIALOG,
    payload: payload
  });
};



// WEBPACK FOOTER //
// ./src/actions/errorDialog.action.js